import { RiLoader4Line, RiRefreshLine } from "@remixicon/react";
import { useState } from "react";
import { toast } from "sonner";
import { fetchClient } from "@/api/client";
import { Button } from "@/components/ui/button";

/// Manual "re-run the mappings" action for the Matching page. Saving a
/// mapping already enqueues a debounced rebuild automatically; this
/// button is the explicit variant for peace of mind (or after changes
/// made outside the dialog). Runs the rebuild synchronously (1-3s).
export function RebuildNowButton() {
	const [running, setRunning] = useState(false);

	async function run() {
		setRunning(true);
		try {
			const { data, error } = await fetchClient.POST(
				"/api/v1/catalogue/rebuild" as never,
				{ params: { query: { target: "farfetch" } } } as never,
			);
			if (error) {
				toast.error("Rebuild failed - try again or check the sync log");
				return;
			}
			const rows = (data as { rowsUpserted?: number } | undefined)?.rowsUpserted;
			toast.success(
				rows != null
					? `Catalogue rebuilt - ${rows} rows updated. The Editor now reflects your mappings.`
					: "Catalogue rebuilt. The Editor now reflects your mappings.",
			);
		} finally {
			setRunning(false);
		}
	}

	return (
		<Button variant="outline" size="sm" onClick={run} disabled={running}>
			{running ? (
				<RiLoader4Line className="mr-1.5 size-4 animate-spin" />
			) : (
				<RiRefreshLine className="mr-1.5 size-4" />
			)}
			Rebuild now
		</Button>
	);
}
